import {
  chargePayment,
  getCompanyCurrentBillingMethod,
  updateBillingMethod,
  chooseBillingMethod,
  getCompanyCredits,
  updateCompanyBillingMethodStatus,
} from '@/resources/companies/companyBilling';
import { BILLING_STATUS } from '@/utils/enumerados';
import BILLING_MESSAGES from '@/constants/billingMessages';

const CHOOSE_BILLING_METHOD = 'CHOOSE_BILLING_METHOD';
const UPDATE_BILLING_METHOD = 'UPDATE_BILLING_METHOD';
const COMPANY_CURRENT_BILLING = 'COMPANY_CURRENT_BILLING';
const CHARGE_PAYMENT = 'CHARGE_PAYMENT';
const UPDATE_STATUS_BILLING_METHOD = 'UPDATE_STATUS_BILLING_METHOD';
const GET_CREDITS = 'GET_CREDITS';

const mutations = {
  [UPDATE_BILLING_METHOD](state, id) {
    state.currentBillingMethodId = id;
  },
  [CHOOSE_BILLING_METHOD](state, id) {
    state.currentBillingMethodId = id;
  },
  [COMPANY_CURRENT_BILLING](state, billingMethod) {
    state.currentBillingMethodId = billingMethod?.billingMethodId ?? null;
    state.activeBillingContractId = billingMethod?.id ?? '';
    state.status = billingMethod?.status ?? '';
    state.value = billingMethod?.value ?? 0;
    state.description = billingMethod?.billingMethod?.description ?? '';
    state.type = billingMethod?.billingMethod?.type ?? '';
    state.startDate = billingMethod?.startDate ?? '';
    state.finishDate = billingMethod?.finishDate ?? '';
  },
  [UPDATE_STATUS_BILLING_METHOD](state, status) {
    state.status = status;
  },
  [CHARGE_PAYMENT](state, payload) {
    state.invoiceUrl = typeof payload === 'string' ? payload : (payload && payload.url) || '';
  },
  [GET_CREDITS](state, credits) {
    state.companyCredits = credits;
  },
};

const actions = {
  async chooseBillingMethod({ commit }, content) {
    const companyId = content.companyId ?? content.companyID;
    const billingMethodId = content.billingMethodId ?? content.billingMethodID;
    const response = await chooseBillingMethod(companyId, billingMethodId);
    if (response.status !== 200) return Promise.reject(response.data);
    return commit(CHOOSE_BILLING_METHOD, response.data?.data?.billingMethodId);
  },
  async updateBillingMethod({ commit }, content) {
    const companyId = content.companyId ?? content.companyID;
    const billingMethodId = content.billingMethodId ?? content.billingMethodID;
    const response = await updateBillingMethod(companyId, billingMethodId);
    if (response.status !== 200) return Promise.reject(response.data);
    return commit(UPDATE_BILLING_METHOD, response.data?.data?.billingMethodId);
  },
  async chargePayment({ commit }, content) {
    const response = await chargePayment(content);
    if (response.status !== 201) return Promise.reject(response.data);
    const payload = response.data?.data;
    commit(CHARGE_PAYMENT, payload);
    const url = typeof payload === 'string' ? payload : payload?.url;
    return url;
  },
  async getCompanyCurrentBillingMethod({ commit }, content) {
    const response = await getCompanyCurrentBillingMethod(content);
    if (response.status !== 200) return Promise.reject(response.data);
    return commit(COMPANY_CURRENT_BILLING, response.data?.data);
  },
  async updateCompanyBillingMethodStatus({ state }, content) {
    const response = await updateCompanyBillingMethodStatus(content);
    if (response.status !== 200) return Promise.reject(response.data);
    return Promise.resolve(state);
  },
  async getCompanyCredits({ commit }, content) {
    const response = await getCompanyCredits(content);
    if (response.status !== 200) return commit(GET_CREDITS, 0);
    return commit(GET_CREDITS, response.data?.data?.amount ?? 0);
  },
};

const state = {
  currentBillingMethodId: null,
  companyCredits: 0,
  invoiceUrl: '',
  status: '',
  activeBillingContractId: '',
  value: 0,
  description: '',
  type: '',
  startDate: '',
  finishDate: '',
};

const getters = {
  /**
   * Indica se há pendência de cobrança (sem forma de pagamento ou status não ativo).
   * Usa state de companyBilling e rootState.companies.company, rootGetters.getLogged.
   */
  hasBillingWarning(moduleState, _moduleGetters, rootState, rootGetters) {
    const company = rootState.companies?.company || {};
    const logged = rootGetters.getLogged;
    if (!logged || !company.seller) return false;
    if (['CADASTRADA', 'PRIMEIRA_VALIDACAO'].includes(company.status)) return false;
    if (!moduleState.currentBillingMethodId && moduleState.companyCredits <= 0) return true;
    if (
      moduleState.currentBillingMethodId &&
      moduleState.status &&
      moduleState.status !== BILLING_STATUS.ATIVO &&
      moduleState.companyCredits <= 0
    )
      return true;
    return false;
  },
  /**
   * Mensagem de aviso para exibir no header/notificação.
   */
  billingWarningMessage(moduleState) {
    if (!moduleState.currentBillingMethodId) return BILLING_MESSAGES.NO_METHOD;
    if (moduleState.status === BILLING_STATUS.AGUARDANDO) return BILLING_MESSAGES.PENDING_INVOICE;
    return '';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
